exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rotator-1-wrapper[data-v-191ad384]{width:auto;max-width:450px;padding-bottom:10px}.speech-bubble[data-v-191ad384]{position:relative;background:#f0f0f0;border-radius:.4em;padding:4px;padding-top:1px}.speech-bubble[data-v-191ad384]:after{content:\"\";position:absolute;left:0;top:50%;width:0;height:0;border:19px solid transparent;border-right-color:#f0f0f0;border-left:0;border-bottom:0;margin-top:-9.5px;margin-left:-19px}.rg-rotator-2-content[data-v-191ad384]{min-width:350px}", ""]);

// exports
